import { useState } from "react";
import { AccountRole } from "../graphql";

const TOKEN_NAME = "authToken";
const ACCOUNT_ID = "accountId";
const ROLE = "role";

// custom hook to handle authToken - we use compositon to decouple the auth system and it's storage
export const useAuthToken = () => {
    const [token, setToken] = useState(() => localStorage.getItem(TOKEN_NAME));
    const [myAccountId, setMyAccountId] = useState(() =>
        localStorage.getItem(ACCOUNT_ID)
    );
    const [role, setMyRole] = useState(() => localStorage.getItem(ROLE));

    // this function allows to save any string in our cookies, under the key "authToken"
    const setAuthToken = (authToken) => {
        localStorage.setItem(TOKEN_NAME, authToken);
        setToken(authToken);
    };

    //this function removes the key "authToken" from our cookies. Useful to logout
    const removeAuthToken = () => {
        localStorage.removeItem(TOKEN_NAME);
        setToken(null);
    };

    const setAccountId = (accountId) => {
        localStorage.setItem(ACCOUNT_ID, accountId);
        setMyAccountId(accountId);
    };

    //this function removes the key "accountId" from our cookies. Useful to logout
    const removeAccountId = () => {
        localStorage.removeItem(ACCOUNT_ID);
        setMyAccountId(null);
    };

    const setRole = (accountId) => {
        localStorage.setItem(ROLE, accountId);
        setMyRole(accountId);
    };

    //this function removes the key "accountId" from our cookies. Useful to logout
    const removeRole = () => {
        localStorage.removeItem(ROLE);
        setMyRole(null);
    };

    return {
        token,
        setAuthToken,
        removeAuthToken,
        accountId: Number(myAccountId),
        role: role as AccountRole,
        setAccountId,
        removeAccountId,
        setRole,
        removeRole
    };
};

export const getToken = () => window.localStorage.getItem(TOKEN_NAME);
